import { Navigate } from 'react-router'
import { useSessionStore } from '../../state'
import LoadingScreen from '../LoadingScreen'

interface AuthGuardProps {
  children: React.ReactNode
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const user = useSessionStore(s => s.user)
  const isAuthenticating = useSessionStore(s => s.isAuthenticating)
  const profile = useSessionStore(s => s.profile)

  if (isAuthenticating) return <LoadingScreen />
  if (!user) return <Navigate to='/signin' />
  const skipEmailVerification =
    import.meta.env.VITE_SKIP_EMAIL_VERIFICATION === 'false'
  if (!skipEmailVerification && !user.emailVerified)
    return <Navigate to='/verify-email' />
  if (profile && !profile.profileComplete)
    return <Navigate to='/complete-profile' />

  return <>{children}</>
}

export default AuthGuard
